<template>
  <div class="page-container">
    <div class="search-box">
      <el-input v-model="params.operator" placeholder="操作人" clearable style="width:160px" @keyup.enter.native="loadData" @clear="loadData" />
      <el-select v-model="params.module" placeholder="操作模块" clearable style="width:160px" @change="loadData">
        <el-option v-for="m in modules" :key="m" :label="m" :value="m" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="loadData">查询</el-button>
      <span class="hint">共 {{ total }} 条操作记录</span>
    </div>

    <div class="table-box">
      <el-table :data="tableData" border v-loading="loading" empty-text="暂无日志" height="100%">
        <el-table-column prop="time" label="时间" width="170" />
        <el-table-column prop="operator" label="操作人" width="130" />
        <el-table-column label="模块" width="120">
          <template slot-scope="scope"><el-tag size="mini" effect="plain">{{ scope.row.module }}</el-tag></template>
        </el-table-column>
        <el-table-column label="动作" width="90">
          <template slot-scope="scope">
            <span :style="{ color: actionColor(scope.row.action) }">{{ scope.row.action }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="target" label="操作对象" min-width="220" />
        <el-table-column prop="ip" label="IP" width="150" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { getAuditLogs } from '@/api/sentinel'

export default {
  name: 'AuditIndex',
  data() {
    return {
      params: { operator: '', module: '' },
      modules: ['厂区管理', '设备管理', '安全管理', '告警中心', '账号管理', '数据中心'],
      tableData: [],
      total: 0,
      loading: false
    }
  },
  mounted() { this.loadData() },
  methods: {
    actionColor(a) {
      return { '新增': '#00b42a', '编辑': '#165dff', '删除': '#f53f3f', '绑定': '#165dff', '解绑': '#ff7d00', '登录': '#86909c', '导出': '#86909c' }[a] || '#1d2129'
    },
    loadData() {
      this.loading = true
      getAuditLogs(this.params).then(res => {
        if (res.code === 200) {
          this.tableData = (res.data && res.data.list) || []
          this.total = res.data.total || 0
        }
      }).finally(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
.search-box { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; flex-wrap: wrap; }
.hint { font-size: 13px; color: #86909c; }
.table-box { background: #fff; padding: 16px; border-radius: 4px; box-shadow: 0 2px 12px rgba(0,0,0,.1); }
</style>
